import md5 from 'blueimp-md5';

const USESDURATION = 300;
const SEC = 1000;
const DURATION = USESDURATION * SEC;

export default class Caching {
	private cache: Common.IMap<RA.ICache<TRA.IResponse<unknown>>> = {};
	private duration = DURATION;

	public clearCache(): void {
		this.cache = {};
	}

	public setDuration(duration: number): void {
		this.duration = duration;
	}

	private getTTL(): number {
		return Date.now();
	}

	private getDiffTime(hashId: string): number {
		const currentTime = Date.now();

		return currentTime - this.cache[hashId].ttl;
	}

	private setCache(hashId: string, data: TRA.IResponse<unknown>): void {
		const ttl = this.getTTL();

		this.cache[hashId] = { ttl, data };
	}

	private isCacheValid(hashId: string): boolean {
		return this.cache[hashId] && this.getDiffTime(hashId) / SEC < this.duration;
	}

	private getHashId(url: string = '', opts = {}): string | undefined {
		let optsStr = '';

		try {
			optsStr = JSON.stringify(opts);
		} catch (e) {
			//
		}

		return optsStr && url ? md5(url, optsStr) : undefined;
	}

	protected getOptions(options: RA.IOptionsRestApi, config?: RA.IConfigOptionsRestApi): RA.IOptionsRestApi {
		const { cacheable = false, url = '', body = {} } = config || {};

		if (cacheable && options.useCache === true) {
			options.cacheId = this.getHashId(url, body);
		}

		return options;
	}

	protected async doRequest<TResponse = TRA.CommonResponse>(
		request: () => Promise<TRA.IResponse<TResponse>>,
		options: RA.IOptionsRestApi
	): Promise<TRA.IResponse<TResponse>> {
		const { useCache, cacheId } = options;
		let response = {};
		let needCaching = false;
		let needRequest = true;

		if (useCache && cacheId) {
			if (this.isCacheValid(cacheId)) {
				response = this.cache[cacheId].data;
				needRequest = false;
			} else {
				needCaching = true;
			}
		}

		if (needRequest) {
			response = await request();
		}

		needCaching && cacheId && this.setCache(cacheId, response as TRA.IResponse<TResponse>);

		return response as TRA.IResponse<TResponse>;
	}
}
